import type { WorkflowType } from '@this/domain/organization/organization2';
import React from 'react';
import {
  SubSection,
  SubSectionTitle
} from '@this/components/organization/setting/workflow_setting_section/shared';
import WorkflowSection from '@this/components/organization/setting/workflow_setting_section/workflow_section';

interface PackageSectionProps {
  packageWorkflowType: WorkflowType;
  packageBufferAmount: number;
  handleChangeWorkflowType: (type: WorkflowType, target: string) => void;
  handleChangeBufferAmount: (amount: number, target: string) => void;
}

const PackageSection: React.FC<PackageSectionProps> = ({
  packageWorkflowType,
  packageBufferAmount,
  handleChangeWorkflowType,
  handleChangeBufferAmount
}) => {
  return (
    <SubSection>
      <SubSectionTitle>パッケージ</SubSectionTitle>

      <WorkflowSection
        description=""
        itemLabel="パッケージ"
        workflowType={packageWorkflowType}
        bufferAmount={packageBufferAmount}
        target="package"
        onChangeWorkflowType={handleChangeWorkflowType}
        onChangeBufferAmount={handleChangeBufferAmount}
      />
    </SubSection>
  );
};

export default PackageSection;
